module.exports = __webpack_public_path__ + "static/media/Nebraska_DHHS_Opioid.acb2712c.png";